import { apiFetch } from '@/apiFetch';
import { responseFilename } from '@/shared/downloadFile';

/** New tabs restore their access in the app before reading private bytes. */
export function attachmentUrl(id: string): string {
  return `/soteria/attachments/${encodeURIComponent(id)}`;
}

export async function fetchAttachmentFile(id: string, signal?: AbortSignal) {
  const response = await apiFetch(
    `/soteria/attachments/${encodeURIComponent(id)}`,
    { signal, cache: 'no-store' },
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return {
    blob: await response.blob(),
    filename: responseFilename(response, 'Attachment'),
  };
}

/** Caller owns this URL and revokes it on unmount. */
export async function fetchAttachmentUrl(id: string): Promise<string> {
  return URL.createObjectURL((await fetchAttachmentFile(id)).blob);
}
